import Vue from 'vue'
import axios from 'axios'

export default {
    state: {
        ignoredUsers: []
    },

    actions: {

        'ignoredUsersModel/fetchIgnoredUsers'(context, data){
            axios.get('/api/ignoreUser').then(
                (response) => {
                    context.commit('ignoredUsersModel/setIgnoredUsers', response.data.ignoredUsers)
                }
            );
        },

        'ignoredUsersModel/toggleIgnoreStatus'(context, data){
            axios.post('/api/ignoreUser', {
                ignoredId: data.ignoredId
            }).then(
                (response) => {
                    if (data.callback && typeof data.callback === 'function') {
                        data.callback();
                    }
                }
            )
        }
    },

    mutations: {
        'ignoredUsersModel/setIgnoredUsers': function (state, ignoredUsers) {
            state.ignoredUsers = ignoredUsers;
        }
    }

}


// WEBPACK FOOTER //
// ./src/ChatRoom/IgnoredUsersModel.js